<div class="responsive-products-box-section">

    <div class="container">

        <!-- Section Title -->
        <div class="section-title" *ngFor="let Content of sectionTitle">
            <h2>{{Content.title}}</h2>
        </div>

        <!-- Products Carousel -->
        <div class="products-slides">

            <owl-carousel-o [options]="productsSlidesOptions">

                <ng-template carouselSlide *ngFor="let Content of singleProductsBox">

                    <div class="product-box-wrapper">

                        <div class="single-products-box">

                            <!-- Product Image -->
                            <div class="products-image">

                                <a [routerLink]="['/product', Content.keywords]"
                                   class="product-image-link">

                                    <img [src]="Content.mainImg"
                                         [alt]="Content.title"
                                         class="responsive-img"
                                         loading="lazy">

                                </a>

                                <!-- Product Buttons -->
                                <ul class="products-button">

                                    <li>
                                        <a [routerLink]="['/product', Content.keywords]"
                                           
                                           title="Quick View">
                                            <i class="bx bx-show-alt"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a [href]="Content.mainImg"
                                           class="popup-btn"
                                           title="Zoom Image">
                                            <i class="bx bx-scan"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a [routerLink]="['/product', Content.keywords]"
                                           title="Product Details">
                                            <i class="bx bx-link"></i>
                                        </a>
                                    </li>

                                </ul>

                            </div>

                            <!-- Product Content -->
                            <div class="products-content">

                                <h3>
                                    <a [routerLink]="['/product', Content.keywords]">
                                        {{Content.title}}
                                    </a>
                                </h3>

                                <!-- Price -->
                                <div class="price">

                                    <span class="new-price">
                                        {{Content.newPrice}}
                                    </span>

                                    <span class="old-price"
                                          *ngIf="Content.oldPrice">
                                        {{Content.oldPrice}}
                                    </span>

                                </div>

                            </div>

                            <!-- Sale -->
                            <span class="on-sale" *ngIf="Content.sale">
                                {{Content.sale}}
                            </span>

                            <!-- Out Of Stock -->
                            <div class="out-of-stock" *ngIf="Content.outOfStock">
                                {{Content.outOfStock}}
                            </div>

                        </div>

                    </div>

                </ng-template>

            </owl-carousel-o>

        </div>

    </div>

</div>